import * as React from 'react';
import theme from '../utils/theme';

export interface SectionHeaderProps {
  title: string;
}

export const SectionHeader = (props: SectionHeaderProps) => (
  <h4 className={theme.section.title}>{props.title}</h4>
);
